import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Timeline, TimelineLite
} from "gsap";
import {SpacierArcadeParsedGameData} from "../../server/data/SpacierArcadeParsedGameData";
import {SAMultiplierAddupView} from "./SAMultiplierAddupView";

export class SAMultiplierAddupEvent{
    static readonly ANIMATE_MULTIPLIERS: string = "saMultiplierAddup_animateMultipliers";
    static readonly MULTIPLIERS_ANIMATION_COMPLETED: string = "saMultiplierAddup_multipliersAnimationCompleted";
}

export class SAMultiplierAddupController {
    private _overlayWildsMultipliers:number[][];
    private _view:SAMultiplierAddupView;

    constructor() {
        this._view = new SAMultiplierAddupView();
        this.addEventHandlers();
    }

    protected addEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:SpacierArcadeParsedGameData):void {
        this._overlayWildsMultipliers = data.overlayWildsMultipliers;
    }

    public animateMultipliers():TimelineLite{
        return this._view.animateMultipliers(this._overlayWildsMultipliers);
    }
}